
const server = {
    // baseURL:'https://local.quattropy.com/emprendimiento/s1/public/',
    // baseURL:'https://emprendimientosvirtuales.com.py/s1_cerro/public/',
    // baseURL:'https://sospy.org/s1_catalogos_v2/public/',
    baseURL: 'https://sospy.org/s1_catalogos/public/',
    // baseURL: 'http://localhost:8091/catalogo/s1_catalogos/public/',
    urlProducto: ''
}

export default server;
